import { Box, Button, Paper, Typography } from "@mui/material";
import PropTypes from "prop-types";
import { lazy, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import LazyLoader from "src/components/layout/Progress/LazyLoader";
import MyDivider from "src/components/layout/MyDivider";

const PersonSelectorSearch = lazy(() =>
  import("src/components/person/PersonSelectorSearch/PersonSelectorSearch")
);
const EditPerson = lazy(() => import("src/components/person/editPerson/EditPerson"));

export default function AddrPerson({ person }) {
  const navigate = useNavigate();

  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    setIsOpen(true);
  }, [person]);

  const handleClose = async () => setIsOpen(false);
  const handleOpen = () => setIsOpen(true);

  const navToPersonId = async (personId) => navigate("/person/" + personId);

  // main render
  return <div className="appWrapper">{isOpen ? renderEditPerson() : renderPage()}</div>;

  function renderPage() {
    return (
      <Box className="center" style={{ height: "70vh" }}>
        <div className="flexCol" style={{ gap: 24, alignItems: "center" }}>
          <Typography variant="h5" color="primary">
            HENKILÖ
          </Typography>
          <MyDivider />
          {person && (
            <Button
              variant="contained"
              onClick={handleOpen}
              fullWidth
              sx={{ width: "400px", height: "50px" }}>
              AVAA HENKILÖ <br /> {person?.personFullName}
            </Button>
          )}
          <LazyLoader>
            <PersonSelectorSearch
              setPersonId={navToPersonId}
              defaultPersonId={null}
              showEditButton={false}
            />
          </LazyLoader>
          <Button
            variant="contained"
            onClick={() => navigate("/")}
            fullWidth
            sx={{ width: "400px", height: "50px" }}>
            ETUSIVULLE
          </Button>
        </div>
      </Box>
    );
  }

  function renderEditPerson() {
    return (
      <div className="center">
        <div style={{ maxWidth: "800px" }}>
          <Paper elevation={3}>
            <LazyLoader>
              <EditPerson personId={person.personId} isOpen={isOpen} onClose={handleClose} />
            </LazyLoader>
          </Paper>
        </div>
      </div>
    );
  }
}

AddrPerson.propTypes = {
  person: PropTypes.object,
};
